module.exports = __webpack_public_path__ + "static/img/商务.4d5779e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/商务.png
// module id = ahea
// module chunks = 3